<template>
  <div class="chart ml16 mr16">
    <canvas id="myChart" class="mychart" ></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from "chart.js";
import ChartPluginTotalLsbel from '@/plugins/chartjs-plugin-total-labels';

export default {
  props: ['affiliateList'],
  data() {
    return {
      chartData: [],
      chartLabel: [],
      chartColor: [],
      xAxesMax: 0,
    }
  },
  methods: {
    page() {
      this.$router.push({name: 'TestWalletDetail'})
    },
    setData() {
      this.chartLabel.splice(0, this.chartLabel.length);
      this.chartData.splice(0, this.chartData.length);
      this.chartColor.splice(0, this.chartColor.length);
      for (var i = 0; i < this.affiliateList.length; i++) {
        this.chartLabel.push(this.affiliateList[i].affiliateItemName);
        this.chartData.push(this.affiliateList[i].cashBackAmount);
        this.chartColor.push(this.affiliateList[i].color);
      }
      console.log();
      this.xAxesMax = Math.max(...this.chartData);
      this.horizontalBar();
    },
    horizontalBar() {
      const ctx = document.getElementById('myChart').getContext('2d');
      const myChart = new Chart(ctx, {
        type: 'horizontalBar',
        plugins: [ChartPluginTotalLsbel.totalLabels],
        data: {
          datasets: [
            {
              label: '',
              data: this.chartData,
              datalabels: {
                display: true
              },
              backgroundColor: this.chartColor,
            }
          ],
          labels: this.chartLabel,
        },
        options: {
          legend: {
            // グラフ上のlabel（datasets）を非表示
            display: false
          },
          scales: {
            yAxes: [
              {
                display: true,
                stacked: false,
                gridLines: {
                  // offsetGridLines: false,
                  display: false
                },
              }
            ],
            xAxes: [
              {
                ticks: {
                  min: 0,
                  stepSize: 500,
                  max: this.xAxesMax + 500,
                  // 下のラベルの数値をカンマ区切り
                  callback(label, index, labels) { /* ここです */
                    return label.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  },
                  afterUpdate(axis) {
                    console.log('axis');
                    console.log(axis);
                  }
                },
              }
            ],
          },
          tooltips: {
            // グラフをクリックした際に発火
            callbacks: {
              label: function(tooltipItem, data) {
                return tooltipItem.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
              }
            }
          }
        }
      });
    },
  },
  mounted() {
    this.setData();
  },
  watch: {
    affiliateList() {
      this.setData();
    }
  }
};
</script>

<style scoped>
.chart {
  border: 1px solid #ccc;
  margin-top: 24px;
}
.mychart {
  padding: 8px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/wallet/Chart.vue